import { render, staticRenderFns } from "./IndexDetail.vue?vue&type=template&id=5287d4e4&scoped=true&"
import script from "./IndexDetail.vue?vue&type=script&lang=js&"
export * from "./IndexDetail.vue?vue&type=script&lang=js&"
import style0 from "./IndexDetail.vue?vue&type=style&index=0&id=5287d4e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5287d4e4",
  null
  
)

export default component.exports